import { __decorate, __metadata } from 'tslib';
import { nameOfClass } from '@tencent/workbench-core';
import SchematicUIService from '../../controllers/base/schematic-ui-service.js';
import { Service } from '../../decorators/class/service.js';
import { BuiltinUiState } from '../store/builtin-state.js';
import { StateManager } from '../store/state-manager.js';

/**
 * UIService级别功能配置服务
 * @public
 */
let ConfigUIService = class ConfigUIService {
    // controller级别开关
    constructor(store) {
        this.store = store;
        // ui service级别开关
        this.toggleMap = new Map();
    }
    /**
     * 禁用UI service
     * @param service - 禁用的UI service
     * @param name - 禁用的configName
     * @param isOn - 是否打开
     */
    toggleUIService(service, name, isOn) {
        let configPerService = this.toggleMap.get(nameOfClass(service));
        if (!configPerService) {
            configPerService = new Set();
            this.toggleMap.set(nameOfClass(service), configPerService);
        }
        if (isOn) {
            configPerService.delete(name);
        }
        else {
            configPerService.add(name);
        }
        if (!this.store.has(BuiltinUiState.ConfigStatus)) {
            this.store.register(BuiltinUiState.ConfigStatus, this.toggleMap);
        }
        this.store.update(BuiltinUiState.ConfigStatus, this.toggleMap);
        if (service instanceof SchematicUIService) {
            // shouldHide需要触发渲染
            service.update();
        }
    }
};
ConfigUIService = __decorate([
    Service({ overridable: true }),
    __metadata("design:paramtypes", [StateManager])
], ConfigUIService);

export { ConfigUIService };
//# sourceMappingURL=config-ui-service.js.map
